/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TextAreaDefault } from './text-area-default.story';
export { default as TextAreaResizable } from './text-area-resizable-style.story';
export { default as TextAreaOptional } from './text-area-optional.story';
export { default as TextAreaError } from './text-area-error.story';
export { default as TextAreaDisabled } from './text-area-disabled.story';
export { default as TextAreaFluid } from './text-area-fluid.story';
export { default as TextAreaSizes } from './text-area-sizes.story';
export { default as TextAreaInformationIcon } from './text-area-information-icon.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TextAreaDefaultSrcRaw from './text-area-default.story?raw';
import TextAreaDisabledSrcRaw from './text-area-disabled.story?raw';
import TextAreaErrorSrcRaw from './text-area-error.story?raw';
import TextAreaFluidSrcRaw from './text-area-fluid.story?raw';
import TextAreaInformationIconSrcRaw from './text-area-information-icon.story?raw';
import TextAreaOptionalSrcRaw from './text-area-optional.story?raw';
import TextAreaResizableSrcRaw from './text-area-resizable-style.story?raw';
import TextAreaSizesSrcRaw from './text-area-sizes.story?raw';

export const TextAreaDefaultSrc = removeLicenseHeader(TextAreaDefaultSrcRaw);
export const TextAreaResizableSrc = removeLicenseHeader(
  TextAreaResizableSrcRaw,
);
export const TextAreaOptionalSrc = removeLicenseHeader(TextAreaOptionalSrcRaw);
export const TextAreaErrorSrc = removeLicenseHeader(TextAreaErrorSrcRaw);
export const TextAreaDisabledSrc = removeLicenseHeader(TextAreaDisabledSrcRaw);
export const TextAreaFluidSrc = removeLicenseHeader(TextAreaFluidSrcRaw);
export const TextAreaSizesSrc = removeLicenseHeader(TextAreaSizesSrcRaw);
export const TextAreaInformationIconSrc = removeLicenseHeader(
  TextAreaInformationIconSrcRaw,
);
